var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigblossom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "big_blossom",
    "data-name": "big blossom",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 582.83,
    height: 583.362,
    viewBox: "0 0 582.83 583.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 582.83,
    height: 583.362,
    fill: "#154436"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_130",
    "data-name": "Group 130",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M290.558,583.362a69.513,69.513,0,0,1-65.5-46.418A69.429,69.429,0,0,1,111.8,470.223,69.46,69.46,0,0,1,45.886,356.532a69.433,69.433,0,0,1-.512-130.45,69.421,69.421,0,0,1,67.982-112.529A69.445,69.445,0,0,1,225.826,45.61a69.441,69.441,0,0,1,130.785.945,69.44,69.44,0,0,1,112.883,66.407,69.464,69.464,0,0,1,64.437,115.345,69.427,69.427,0,0,1,4.195,131.2,69.485,69.485,0,0,1-69.085,110.678,69.452,69.452,0,0,1-113.258,67.608,69.581,69.581,0,0,1-65.225,45.571",
    transform: "translate(0 0.008)",
    fill: "#154436"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigblossom);
export default __webpack_public_path__ + "static/media/big blossom.7ad81a14c5a474cd18a3c8c6f57fa80b.svg";
export { ForwardRef as ReactComponent };